module.exports = __webpack_public_path__ + "img/orange_018.2f00c4d1.png";